import { light, dark, gray, primary, danger, success, warning, red, green, blue, yellow, secondary, info, cyan } from './bootstrap.js';

export const colorLight = dark;
export const colorDark = light;
export const bgLight = light;
export const bgDark = dark;
export const borderLight = gray[2];
export const borderDark = gray[6];
export const btnPrimary = primary;
export const btnPrimaryActive = blue[6];
export const btnPrimaryHover = blue[5];
export const btnSecondary = secondary;
export const btnSecondaryActive = gray[7];
export const btnSecondaryHover = gray[6];
export const btnDisabled = gray[5];
export const btnSuccess = success;
export const btnSuccessActive = green[6];
export const btnSuccessHover = green[5];
export const btnInfo = info;
export const btnInfoActive = cyan[5];
export const btnInfoHover = cyan[6];
export const btnWarning = warning;
export const btnWarningActive = yellow[6];
export const btnWarningHover = yellow[5];
export const btnDanger = danger;
export const btnDangerActive = red[6];
export const btnDangerHover = red[5];
export const btnLight = light;
export const btnLightActive = gray[2];
export const btnLightHover = gray[1];
export const btnDark = dark;
export const btnDarkActive = gray[7];
export const btnDarkHover = gray[6];
export const btnLink = 'transparent'; // Link button background should be transparent
export const btnLinkHover = 'transparent';
export const btnLinkActive = 'transparent';
export const linkColor = 'LinkText';
export const scrollbarColor = primary;
export const scrollbarTrack = gray[8];
